import {adminHttpClient} from "../commons/adminHttpClient";


const deleteIndustry = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/Industries/Delete`, {
        data:{id : id}
    })
}

export default deleteIndustry;